<div class="form-contact-info">
  <div id="formContactInfoTitle" class="subtitle" [innerHTML]="copyService.copies.form_contact_title"></div>
  
  <form id="formContactInfo" class="form row" [formGroup]="formGroup">
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_contact_phone_label }}"
        msgErr="{{ copyService.copies.form_contact_phone_error }}">
        <input vclInput placeholder="{{ copyService.copies.form_contact_phone_placeholder }}"
          id="inputValuePhone" maxlength="10" type="text"
          (input)="reactiveInputChangePhone()" (focus)="inputPhone($event)" (focusout)="outPhone($event)"
          formControlName="phone">  
      </vcl-form-field>
      <span class="note" *ngIf="product_select.code === '951'">{{copyService.copies.form_contact_phone_note_living}}</span>
    </div>

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_contact_email_label }}"
        msgErr="{{ copyService.copies.form_contact_email_error }}">
        <input vclInput placeholder="{{ copyService.copies.form_contact_email_placeholder }}"
          id="inputValueEmail" type="email"
          (input)="reactiveInputChangeEmail()" formControlName="email">
      </vcl-form-field>
      <span class="note" *ngIf="product_select.code !== '951'">{{copyService.copies.form_contact_email_note}}</span>
      <span class="note" *ngIf="product_select.code === '951'">{{copyService.copies.form_contact_email_note_living}}</span>
    </div>
  </form>
</div>
<app-controls id="formContactInfoBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_contact_btn" [nextDisabled]="!formGroup.valid" (next)="next()"></app-controls>
